import { DateTimeFactory } from "../../../../../../../localization/useDateTime"
import { WeeklySchedule } from "../../../../../../../supplier/admin/merchant/merchants/supplierMerchantsTypes"
import { CreateOpeningHoursFormValues, DaySchedule } from "../openingHoursTypes"

export const prepareInitialValues = (
    dateTimeFactory: DateTimeFactory,
    openingHours?: WeeklySchedule[],
): CreateOpeningHoursFormValues => {
    const defaultTimes: DaySchedule = {
        open: null,
        close: null,
        isOpen: false,
    }

    const initialValues = {
        monday: defaultTimes,
        tuesday: defaultTimes,
        wednesday: defaultTimes,
        thursday: defaultTimes,
        friday: defaultTimes,
        saturday: defaultTimes,
        sunday: defaultTimes,
    }

    if (openingHours) {
        openingHours.forEach(({ weekDay, hours }) => {
            const day = weekDay.toLowerCase() as keyof CreateOpeningHoursFormValues
            initialValues[day] = {
                open: dateTimeFactory.fromISO(hours.open),
                close: dateTimeFactory.fromISO(hours.close),
                isOpen: Boolean(hours.open) && Boolean(hours.close),
            }
        })
    }

    return initialValues
}
